import { render, staticRenderFns } from "./PProcessClassifyModal.vue?vue&type=template&id=4d96e993&"
import script from "./PProcessClassifyModal.vue?vue&type=script&lang=js&"
export * from "./PProcessClassifyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports